import React from 'react'
import createReactClass from 'create-react-class'
import ShowTextModalPanel from './modal-panels/show-cell-text-modal-panel'

export default createReactClass({
  renderModalPanel () {
    if (this.props.showModal) {
      return (
        <div>
          <ShowTextModalPanel {...this.props}/>
        </div>
      )
    }
    return false
  },
  render () {
    return (
      <span>
        {this.renderModalPanel()}
      </span>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/show-extra-text-panel.js